export default {
  name: 'delivery-schedule',
  created () {
    this.$store.dispatch('SHOP_SEARCH')
    if (this.$store.getters.canManage && !this.shopId) {
      this.shopId = this.$store.getters.currentShopId
    }

    if (this.$router.currentRoute.query.keep !== 'true') {
      this.clearSearchParams()
      this.search(null)
    } else {
      if (this.$store.getters.deliverySearchParams) {
        this.shopId = this.$store.getters.deliverySearchParams['shop_id']
        this.facilityId = this.$store.getters.deliverySearchParams['facility_id']
        this.facilityName = this.$store.getters.deliverySearchParams['facility_name']
        this.clinicId = this.$store.getters.deliverySearchParams['clinic_id']
        this.clinicName = this.$store.getters.deliverySearchParams['clinic_name']
        this.careOfficeId = this.$store.getters.deliverySearchParams['care_office_id']
        this.careOfficeName = this.$store.getters.deliverySearchParams['careoffice_name']
        this.patientName = this.$store.getters.deliverySearchParams['patient_name']
        this.startDate = this.$store.getters.deliverySearchParams['start_date']
      }
    }
  },
  data () {
    return {
      patientName: '',
      facilityId: null,
      facilityName: '',
      clinicId: null,
      clinicName: '',
      careOfficeId: null,
      careOfficeName: '',
      shopId: null,
      startDate: null
    }
  },
  computed: {
    patientInfos () {
      return this.$store.getters.patientInfos
    },
    facilities () {
      return this.$store.getters.facilities
    },
    careOffices () {
      return this.$store.getters.careOffices
    },
    clinics () {
      return this.$store.getters.clinics
    },
    shops () {
      return this.$store.getters.shops
    },
    canManage () {
      return this.$store.getters.canManage
    },
    today () {
      return this.$store.getters.today
    },
    days () {
      return this.$store.getters.days
    },
    delivery () {
      return this.$store.getters.delivery
    },
    yearMonth() {
      return this.$store.getters.yearMonth
    },
    currentStartDate () {
      return this.$store.getters.currentStartDate
    },
    prevStartDate () {
      return this.$store.getters.prevStartDate
    },
    nextStartDate () {
      return this.$store.getters.nextStartDate
    },
    isFacility () {
      return this.$store.getters.isFacility
    },
    isCareOffice () {
      return this.$store.getters.isCareOffice
    },
    isClinic () {
      return this.$store.getters.isClinic
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  methods: {
    prevWeek () {
      this.search(this.$store.getters.prevStartDate)
    },
    nextWeek () {
      this.search(this.$store.getters.nextStartDate)
    },
    search (startDate) {
      var url   = null
      var clear = true

      var data = null

      this.startDate = startDate
      var data = {'patient_name': this.patientName, 'facility_id': this.facilityId, 'facility_name': this.facilityName, 'clinic_id': this.clinicId, 'clinic_name': this.clinicName, 'care_office_id': this.careOfficeId, 'careoffice_name': this.careOfficeName, 'shop_id': this.shopId, 'start_date': this.startDate}

      this.$store.dispatch('DELIVERY_SEARCH',  {url: url, clear: clear, data: data})
    },
    getFacilities () {
      this.facilityId = null
      this.$store.dispatch('FACILITY_SEARCH', {data: {'facility_name': this.facilityName, 'shop_id': this.shopId}})
    },
    clearFacilities () {
      this.$store.dispatch('FACILITY_CLEAR', 500)
    },
    setSearchFacility (facilityId, facilityName) {
      console.log("setFacilityName - facilityName: " + facilityName)
      this.facilityId   = facilityId
      this.facilityName = facilityName
    },
    getCareOffices () {
      this.careOfficeId = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {data: {'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}})
    },
    clearCareOffices () {
      this.$store.dispatch('CARE_OFFICE_CLEAR', 500)
    },
    setSearchCareOffice (careOfficeId, careOfficeName) {
      console.log("setCareOfficeName - careOfficeName: " + careOfficeName)
      this.careOfficeId   = careOfficeId
      this.careOfficeName = careOfficeName
    },
    getClinics () {
      this.clinicId = null
      this.$store.dispatch('CLINIC_SEARCH', {data: {'clinic_name': this.clinicName, 'shop_id': this.shopId}})
    },
    clearClinics () {
      this.$store.dispatch('CLINIC_CLEAR', 500)
    },
    setSearchClinic (clinicId, clinicName) {
      console.log("setClinicName - clinicName: " + clinicName)
      this.clinicId   = clinicId
      this.clinicName = clinicName
    },
    getShops () {
      this.$store.dispatch('SHOP_SEARCH')
    },
    showMedicineList (patientId) {
      this.$store.dispatch('PATIENT_SHOW', {patientId: patientId})

      this.$router.push({ path: '/patient/' + patientId + '/medicines', query: { prev: 'delivery_schedule'}})
    },
    clearSearchParams: function() {
      this.shopId = null
      if (this.$store.getters.canManage && !this.shopId) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.facilityId = null
      this.facilityName = ''
      this.clinicId = null
      this.clinicName = ''
      this.careOfficeId = null
      this.careOfficeName = ''
      this.PatientName = ''
      this.startDate = null

      this.$store.dispatch('CLEAR_DELIVERY_SEARCH_PARAMS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/delivery-schedule.js